<app-alert-container></app-alert-container>

<div class="ibox">
  <div class="ibox-title">
    <h5>Round Information</h5>
    <div class="ibox-tools">
      <button class="btn btn-primary btn-xs" type="button" (click)="addRound()">
        <i class="fa fa-plus"></i> Add Round
      </button>
    </div>
  </div>
  <div class="ibox-content">
    <!-- Show message when no tournament is selected -->
    @if (rounds().length === 0) {
    <div class="text-center m-t-lg">
      <h3 class="text-muted">No rounds available</h3>
      <p class="text-muted">Please select a tournament or add a new round</p>
    </div>
    }

    <!-- Round tabs and form -->
    @if (rounds().length > 0) {
    <div class="round-information">
      <!-- Round Tabs -->
      <ul class="nav nav-tabs round-tabs">
        @for (round of rounds(); track round.roundId) {
        <li [class.active]="isSelectedRound(round)">
          <a (click)="selectRound(round)" style="cursor: pointer">
            Round {{ round.number }}
            @if (round.active) {
            <i class="fa fa-check check-icon" style="margin-left: 8px"></i>
            }
          </a>
        </li>
        }
      </ul>

      <!-- Round Form -->
      @if (selectedRound()) {
      <form class="form-horizontal round-form">
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label class="col-sm-3 control-label">Start Date:</label>
              <div class="col-sm-5">
                <div class="input-group date">
                  <span class="input-group-addon"
                    ><i class="fa fa-calendar"></i
                  ></span>
                  <input
                    #startDateInput
                    type="date"
                    class="form-control"
                    [ngModel]="formatDateForInput(selectedRound()?.startDate!)"
                    (ngModelChange)="
                      updateRoundProperty('startDate', parseInputDate($event))
                    "
                    name="startDate"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">End Date:</label>
              <div class="col-sm-5">
                <div class="input-group date">
                  <span class="input-group-addon"
                    ><i class="fa fa-calendar"></i
                  ></span>
                  <input
                    type="date"
                    class="form-control"
                    [ngModel]="formatDateForInput(selectedRound()?.endDate!)"
                    (ngModelChange)="
                      updateRoundProperty('endDate', parseInputDate($event))
                    "
                    name="endDate"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Cut:</label>
              <div class="col-sm-5">
                <input
                  type="number"
                  class="form-control"
                  name="cutSize"
                  placeholder="Enter cut value"
                  [ngModel]="selectedRound()?.cutSize ?? ''"
                  (ngModelChange)="updateCutSize($event)"
                />
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Cut Type:</label>
              <div class="col-sm-5">
                <select
                  class="form-control"
                  name="cutType"
                  [disabled]="
                    selectedRound()?.cutSize === undefined ||
                    selectedRound()?.cutSize === null
                  "
                  [ngModel]="selectedRound()?.cutType ?? ''"
                  (ngModelChange)="updateCutType($event)"
                >
                  <option value="">Select Cut Type</option>
                  <option value="Players">Players</option>
                  <option value="Teams">Teams</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Reset Scores:</label>
              <div class="col-sm-5">
                <div class="btn-group" role="group">
                  <button
                    type="button"
                    class="btn btn-default"
                    name="resetScoresTrue"
                    [disabled]="
                      selectedRound()?.cutSize === undefined ||
                      selectedRound()?.cutSize === null
                    "
                    [class.active]="selectedRound()?.resetScores === true"
                    (click)="setResetScores(true)"
                  >
                    True
                  </button>
                  <button
                    type="button"
                    class="btn btn-default"
                    name="resetScoresFalse"
                    [disabled]="
                      selectedRound()?.cutSize === undefined ||
                      selectedRound()?.cutSize === null
                    "
                    [class.active]="selectedRound()?.resetScores === false"
                    (click)="setResetScores(false)"
                  >
                    False
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label class="col-sm-3 control-label">Status:</label>
              <div class="col-sm-5">
                <span
                  class="status-badge"
                  [ngClass]="getStatusBadgeClass(selectedRound()?.status)"
                >
                  {{ getStatusDisplayText(selectedRound()?.status) }}
                </span>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Created On:</label>
              <div class="col-sm-5">
                <app-audit-info
                  [dateUtc]="selectedRound()?.createdOnUtc"
                ></app-audit-info>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Modified On:</label>
              <div class="col-sm-5">
                <app-audit-info
                  [dateUtc]="selectedRound()?.modifiedOnUtc"
                ></app-audit-info>
              </div>
            </div>
            <div class="form-group">
              <label class="col-sm-3 control-label">Actions:</label>
              <div class="col-sm-9">
                <div class="m-b-sm">
                  <button
                    class="btn btn-danger"
                    type="button"
                    (click)="confirmRemoveScores()"
                    [disabled]="selectedRound()?.official"
                  >
                    <i class="fa fa-trash"></i> Remove Scores
                  </button>
                </div>
                <div class="m-b-sm">
                  <button
                    class="btn btn-primary"
                    type="button"
                    (click)="toggleRoundActive(selectedRound()!)"
                  >
                    @if (selectedRound()?.active) {
                    <i class="fa fa-toggle-off"></i> Mark Inactive } @else {
                    <i class="fa fa-toggle-on"></i> Mark Active }
                  </button>
                </div>
                <div class="m-b-sm">
                  <button
                    class="btn btn-primary"
                    type="button"
                    (click)="confirmCloseRound()"
                    [disabled]="selectedRound()?.official"
                  >
                    <i class="fa fa-lock"></i> Close Round
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12">
            <div class="pull-right">
              <button
                class="btn btn-danger"
                type="button"
                (click)="confirmRemoveRound()"
                style="margin-right: 10px"
              >
                <i class="fa fa-trash"></i> Remove
              </button>
              <button
                class="btn btn-primary"
                type="button"
                (click)="saveRound(selectedRound()!)"
                [disabled]="!isDirty() || isSaving()"
              >
                <i class="fa fa-save"></i> Save
              </button>
            </div>
          </div>
        </div>
      </form>
      }
    </div>
    }
  </div>
</div>

<!-- Router outlet for child routes (pairings, scorecards, etc.) -->
<router-outlet></router-outlet>

<!-- Confirmation Dialog -->
<app-confirmation-dialog
  (confirmed)="onConfirmationDialogConfirmed($event)"
></app-confirmation-dialog>
